export default __webpack_public_path__ + "static/media/wh_5.8d341d16.mp3";